export const dateFormat = 'YYYY-MM-DD';

export const dateTimeFormat = 'YYYY-MM-DD HH:MM';
